<template>
    <div
        class="tr m-promoPreviewDetails overflow-visible pt-0"
        :class="{ '-noPaddingTop': previewType === 'group-accept' }"
    >
        <template
            v-if="previewType !== 'group-accept' && previewType !== 'labels'"
        >
            <div class="d-flex">
                <h6 class="typo--headline text-primary w-50">Szczegóły</h6>
                <h6
                    v-if="promotion.type !== PROMO_TYPES.SALES_TARGET"
                    class="typo--headline text-primary d-sm-block d-none w-50"
                >
                    Limity użyć
                </h6>
            </div>
            <promotion-list-details :promotion="promotion" />
            <div
                class="
                    m-promoPreviewDetails__productSet
                    mt-3 d-flex flex-wrap justify-content-between
                "
            >
                <div
                    v-if="!isNoItemsPromo"
                    class="d-flex align-items-center mb-2 pr-3"
                >
                    <h6
                        class="typo--headline text-primary mb-0"
                        v-if="
                            !isBonded &&
                                (products || productSets) &&
                                previewType !== 'group-accept'
                        "
                    >
                        Produkty promocyjne
                        <span
                            v-if="
                                productsPagination &&
                                    productsPagination.totalRecords
                            "
                        >
                            ({{ productsPagination.totalRecords }})
                        </span>
                    </h6>
                </div>
                <div
                    v-if="productSets && productSets[0] && !isBonded"
                    class="m-promoPreviewDetails__productSetPrice mb-2"
                >
                    <span>Maksymalna cena zestawu:</span>
                    <span class="u-price">
                        &nbsp;{{ productSets[0].price | currency(promotion.type) }}
                    </span>
                </div>
            </div>
        </template>
        <div v-if="promotionalProducts">
            <!-- promotion bonded -->
            <template v-if="previewType !== 'group-accept' && isBonded">
                <!-- set trigger -->
                <div
                    class="px-3 pt-3 border border-dark mt-3 rounded"
                    :style="
                        `background-color: var(--color-gray-100);
                        --background-products: var(--color-gray-100);`
                    "
                    v-if="setTrigger"
                >
                    <div
                        class="
                            m-promoPreviewDetails__productSet
                            d-flex flex-wrap justify-content-between
                        "
                    >
                        <div class="d-flex align-items-center mb-2 pr-3">
                            <h6
                                class="typo--headline typo--semi mb-0"
                                v-if="products || productSets"
                            >
                                Produkty wywołujące promocję
                                <span v-if="setTrigger.pagination">
                                    ({{ setTrigger.pagination.totalRecords }})
                                </span>
                            </h6>
                            <a-icon
                                style="width: 20px; height: 20px; margin-top: 2px;"
                                icon="Info"
                                v-tooltip="
                                    `Lista produktów, których zakup wyzwala promocję. Informację
                                    o tym, ile produktów z listy konsument musi nabyć,
                                    znajdziesz poniżej`
                                "
                            />
                        </div>
                    </div>
                    <div v-if="previewType === 'labels'">
                        <slot name="promotionShops"></slot>
                    </div>
                    <div v-else>
                        <product-tree
                            :products="setTrigger.product_set_dict_products"
                            :product-set-id="setTrigger.id"
                            :set-weight="setTrigger.required_weight"
                            component-name="PromotionPreviewProduct"
                            preview-type="promo-list"
                            :promotion="promotion"
                            fetching-method-name="fetchProductsByPromoGroupPromo"
                        />
                    </div>
                    <div class=""></div>
                    <page-preloader
                        v-if="
                            productsStatus === 'loading' &&
                                promotion.fetchingSetId === setTrigger.id &&
                                previewType !== 'labels'
                        "
                        min-height="123px"
                    />
                    <the-btn
                        class="mb-3"
                        v-if="
                            setTrigger.pagination &&
                                setTrigger.pagination.nextPage &&
                                previewType !== 'labels'
                        "
                        @click.native="
                            showMoreProducts({
                                setId: setTrigger.id
                            })
                        "
                    >
                        Pokaż więcej produktów
                    </the-btn>
                    <h6
                        class="set-bonded-description --trigger"
                        v-text="
                            getPromoBondedWording(
                                'partial',
                                'ProductSet::Trigger'
                            )
                        "
                        :data-desc="
                            getPromoBondedWording('full', 'ProductSet::Trigger')
                        "
                        v-sticky-elem="{
                            direction: 'bottom',
                            background: 'var(--color-gray-100)'
                        }"
                    />
                </div>
                <div
                    v-if="setTrigger && setPromotional"
                    class="d-flex align-items-center justify-content-around my-3"
                >
                    <a-icon class="text-primary" icon="ArrowDown" />
                </div>
                <div
                    class="px-3 pb-3 border border-dark mt-3 rounded"
                    :style="
                        `background-color: var(--active-promo-bg);
                        --background-products: var(--active-promo-bg);`
                    "
                    v-if="setPromotional"
                >
                    <!-- set promotional -->
                    <h6
                        class="set-bonded-description --promotional"
                        v-text="
                            getPromoBondedWording(
                                'partial',
                                'ProductSet::Promotional'
                            )
                        "
                        :data-desc="
                            getPromoBondedWording(
                                'full',
                                'ProductSet::Promotional'
                            )
                        "
                        v-sticky-elem="{
                            direction: 'top',
                            background: 'var(--active-promo-bg)'
                        }"
                    />
                    <div
                        class="
                            m-promoPreviewDetails__productSet
                            d-flex flex-wrap justify-content-between
                        "
                    >
                        <div class="d-flex align-items-center mb-2 pr-3">
                            <h6
                                class="typo--headline typo--semi mb-0"
                                v-if="products || productSets"
                            >
                                Produkty rabatowane
                                <span v-if="setPromotional.pagination">
                                    ({{ setPromotional.pagination.totalRecords }})</span>
                            </h6>
                            <a-icon
                                style="width: 20px; height: 20px; margin-top: 2px;"
                                icon="Info"
                                v-tooltip="'Produkty, które będą rabatowane'"
                            />
                        </div>
                    </div>
                    <div v-if="previewType === 'labels'">
                        <slot name="promotionShops"></slot>
                    </div>
                    <div v-else>
                        <template v-if="setPromotional">
                            <product-tree
                                :products="
                                    setPromotional.product_set_dict_products
                                "
                                :product-set-id="setPromotional.id"
                                :set-weight="setPromotional.required_weight"
                                :component-name="'PromotionPreviewProduct'"
                                :preview-type="'promo-list'"
                                :promotion="promotion"
                                :fetching-method-name="
                                    'fetchProductsByPromoGroupPromo'
                                "
                            />
                        </template>
                    </div>

                    <!-- loader -->
                    <page-preloader
                        v-if="
                            productsStatus === 'loading' &&
                                promotion.fetchingSetId === setPromotional.id &&
                                previewType !== 'labels'
                        "
                        min-height="123px"
                    />

                    <!-- show more button -->
                    <the-btn
                        v-if="
                            setPromotional.pagination &&
                                setPromotional.pagination.nextPage &&
                                previewType !== 'labels'
                        "
                        @click.native="
                            showMoreProducts({
                                setId: setPromotional.id
                            })
                        "
                    >
                        Pokaż więcej produktów
                    </the-btn>
                </div>

                <page-preloader
                    v-if="
                        !setTrigger &&
                            !setPromotional &&
                            productsStatus === 'loading' &&
                            previewType !== 'labels'
                    "
                    min-height="123px"
                />
            </template>

            <!-- promotions not bonded -->
            <template v-else>
                <div
                    v-if="
                        previewType === 'group-accept' ||
                            previewType === 'labels'
                    "
                >
                    <slot name="promotionShops"></slot>
                </div>
                <div v-else>
                    <template v-if="productSets.length > 0">
                        <div
                            v-for="(productSet, idx) in productSets"
                            :key="idx"
                        >
                            <product-tree
                                v-if="previewType === 'promo-labels'"
                                :products="promotionalProducts"
                                :product-set-id="productSet.id"
                                :set-weight="productSet.required_weight"
                                component-name="PromotionPreviewProduct"
                                preview-type="promo-labels"
                                :promotion="promotion"
                                fetching-method-name="loadLabelProducts"
                            />
                            <product-tree
                                v-else
                                :products="productSet.product_set_dict_products"
                                :product-set-id="productSet.id"
                                :set-weight="productSet.required_weight"
                                component-name="PromotionPreviewProduct"
                                preview-type="promo-list"
                                :promotion="promotion"
                                fetching-method-name="fetchProductsByPromoGroupPromo"
                            />
                        </div>
                    </template>
                    <template v-else-if="promotionalProducts.length > 0">
                        <product-tree
                            v-if="previewType === 'promo-labels'"
                            :products="promotionalProducts"
                            component-name="PromotionPreviewProduct"
                            preview-type="promo-labels"
                            :promotion="promotion"
                            fetching-method-name="loadLabelProducts"
                        />
                        <product-tree
                            v-else
                            :products="promotionalProducts"
                            component-name="PromotionPreviewProduct"
                            preview-type="promo-list"
                            :promotion="promotion"
                            fetching-method-name="fetchProductsByPromoGroupPromo"
                        />
                    </template>
                </div>
                <page-preloader
                    v-if="
                        productsStatus === 'loading' && previewType !== 'labels'
                    "
                    min-height="123px"
                />
                <the-btn
                    v-if="
                        productsPagination &&
                            productsPagination.nextPage &&
                            previewType !== 'group-accept' &&
                            previewType !== 'labels'
                    "
                    @click.native="
                        showMoreProducts({
                            setId: productSets[0] && productSets[0].id
                        })
                    "
                >
                    Pokaż więcej produktów
                </the-btn>
            </template>
        </div>
    </div>
</template>

<script>
import promoBonded from '@/mixins/promoBonded'
import PromotionListDetails from './PromotionListDetails'
import { PROMO_TYPES } from '@/utils/constants/promo-types'

export default {
    components: { PromotionListDetails },
    mixins: [promoBonded],
    props: {
        groupId: { type: Number, required: false, default: null },
        previewType: {
            type: String,
            default: ''
        },
        promotion: { type: Object, required: true }
    },
    created() {
        this.PROMO_TYPES = PROMO_TYPES
    },
    computed: {
        products() {
            return this.promotion.products || []
        },
        productSets() {
            return this.promotion.product_sets || []
        },
        promotionalProducts() {
            return this.products
        },
        setTrigger() {
            return this.productSets.find(s => s.type === 'ProductSet::Trigger')
        },
        setPromotional() {
            return this.productSets.find(
                s => s.type === 'ProductSet::Promotional'
            )
        },
        promoBondedWording() {
            if (!this.isBonded) return {}

            const { type, product_sets: productSets } = this.promotion
            const setTrigger = productSets.find(
                s => s.type === 'ProductSet::Trigger'
            )
            const setPromotional = productSets.find(
                s => s.type === 'ProductSet::Promotional'
            )

            // general sentence
            const general = `Sprzedaj ${this.$options.filters.plurals(
                +setTrigger.required_weight,
                'dowolny produkt',
                'dowolne produkty',
                'dowolnych produktów'
            )} z tego zestawu w cenie regularnej`

            // trigger set sentence
            const trigger = `Sprzedaj ${this.$options.filters.plurals(
                +setTrigger.required_weight,
                'dowolny produkt',
                'dowolne produkty',
                'dowolnych produktów'
            )} z tego zestawu w cenie regularnej`

            // promotional set sentence
            let promotional = `a ${this.$options.filters.plurals(
                +setPromotional.required_weight,
                'produkt',
                'produkty',
                'produktów'
            )} z tego zestawu `

            if (type === 'Promo::Bonded') {
                promotional += `sprzedasz za ${this.$options.filters.currency(
                    setPromotional.price
                )}`
            }

            if (type === 'Promo::BondedQuota') {
                promotional += `sprzedasz ze zniżką ${this.$options.filters.currency(
                    setPromotional.discount_amount
                )}`
            }

            if (type === 'Promo::BondedPercentage') {
                promotional += `sprzedasz ze zniżką ${setPromotional.discount_percentage}%`
            }

            return {
                trigger,
                promotional,
                general
            }
        },

        isNoItemsPromo() {
            return this.$store.getters.isNoItemsPromo(this.promotion.type)
        },

        productsStatus() {
            return this.promotion.productsStatus
        },

        productsPagination() {
            return this.promotion.productsPagination
        }
    },
    methods: {
        getPromoBondedWording(wordingType, setType) {
            const { type, product_sets: productSets } = this.promotion

            const isTrigger = setType === 'ProductSet::Trigger'
            const isPromotional = setType === 'ProductSet::Promotional'

            const setTrigger = productSets.find(
                s => s.type === 'ProductSet::Trigger'
            )
            const setPromotional = productSets.find(
                s => s.type === 'ProductSet::Promotional'
            )

            const { currency, plurals } = this.$options.filters

            // plurals trigger products
            const triggerProducts = plurals(
                +setTrigger.required_weight,
                'dowolny produkt',
                'dowolne produkty',
                'dowolnych produktów'
            )

            // plurals trigger products
            const promotionalProducts = plurals(
                +setPromotional.required_weight,
                'produkt',
                'produkty',
                'produktów'
            )

            // set sentence
            let sentence
            if (wordingType === 'full') {
                if (isTrigger) {
                    sentence = `Sprzedaj ${triggerProducts} z tego zestawu w cenie regularnej, a ${promotionalProducts} z zestawu rabatowanych sprzedasz `
                }

                if (isPromotional) {
                    sentence = `Sprzedaj ${triggerProducts} z zestawu produktów wywołujących w cenie regularnej, a ${promotionalProducts} z tego zestawu sprzedasz `
                }
            } else {
                if (isTrigger) {
                    sentence = `Sprzedaj ${triggerProducts} z tego zestawu w cenie regularnej`
                }

                if (isPromotional) {
                    sentence = `a ${promotionalProducts} z tego zestawu sprzedasz `
                }
            }

            if (wordingType === 'full' || isPromotional) {
                if (type === 'Promo::Bonded') {
                    sentence += `za ${currency(setPromotional.price)}`
                }

                if (type === 'Promo::BondedQuota') {
                    sentence += `z łącznym rabatem ${currency(
                        +setPromotional.required_weight *
                            setPromotional.discount_amount
                    )} (-${currency(setPromotional.discount_amount)} / szt.)`
                }

                if (type === 'Promo::BondedPercentage') {
                    sentence += `ze zniżką ${setPromotional.discount_percentage}%`
                }
            }

            return sentence
        },

        async showMoreProducts(params) {
            const payload = {
                per: 100,
                main: true,
                groupId: this.groupId,
                promoId: this.promotion.id,
                productSetId: params.setId
            }

            if (this.previewType === 'labels') {
                this.$store.dispatch('loadLabelsProductsAndResources', {
                    ...payload,
                    promo: this.promotion
                })
            } else if (this.previewType === 'promo-labels') {
                this.$store.dispatch('loadLabelProducts', {
                    params: {
                        ...payload,
                        page: this.productsPagination.nextPage
                    },
                    promo: this.promotion,
                    productSetId: payload.productSetId
                })
            } else if (this.previewType === 'group-accept') {
                const res = await this.$store.dispatch(
                    'fetchProductsByPromoGroupPromo',
                    {
                        ...payload,
                        fromSelectedGroups: true
                    }
                )

                if (this.promotion.all_eans_present) {
                    return
                }

                this.$store.dispatch('setMerchantEansInSelectedPromoGroup', {
                    products: res,
                    promotion: this.promotion,
                    params: {
                        per: 99999
                    }
                })
            } else {
                this.$store.dispatch('fetchProductsByPromoGroupPromo', payload)
            }
        }
    }
}
</script>
